﻿import $ from "jquery";
import { GuiBase } from "../GuiBase";
export class GuiOcrAuswahl extends GuiBase {

    constructor() {
        super("Dokument");
    }

    protected attachEvents() {
        $("#btnOcr").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.doAction(e));
        $("#btnERechnung").on("click", (e: JQuery.ClickEvent<HTMLElement, undefined, HTMLElement, HTMLElement>) => this.doAction(e));
    }

}
